import Autoplay from 'embla-carousel-autoplay'
import { useRef } from 'react'
import CardServicosCompacto from './cardServicosCompacto'
import {
  Carousel,
  CarouselButtonsMobile,
  CarouselContent,
  CarouselItem,
} from './carousel'
import Container from './container'

export default function CardsFinops({ title, description, cards = [] }) {
  const scrollRef = useRef(null)

  return (
    <div className="w-full bg-[#040116] pt-2.5 pb-5 md:py-16">
      <Container className="text-white">
        <h2 className="font-inter-light text-center text-2xl lg:text-5xl mb-8">
          {title}
        </h2>
        <p className="font-inter-regular text-sm md:text-xl text-center mb-16">
          {description}
        </p>
        <div className="hidden md:grid md:grid-cols-2 gap-4">
          {cards.map((card, index) => (
            <CardServicosCompacto
              key={index}
              title={card.title}
              text={card.text}
              icon={card.icon}
              iconHover={card.iconHover || card.icon}
              glowColor={card.glowColor || '#FC0021'}
              iconBgColor="#11112E"
              origin="finops"
              className="h-full w-full"
            />
          ))}
        </div>
        <div ref={scrollRef} className="md:hidden">
          <Carousel
            plugins={[
              Autoplay({
                delay: 4000,
              }),
            ]}
          >
            <CarouselContent>
              {cards.map((card, index) => (
                <CarouselItem key={index}>
                  <div>
                    <CardServicosCompacto
                      key={index}
                      title={card.title}
                      text={card.text}
                      icon={card.icon}
                      iconHover={card.iconHover || card.icon}
                      glowColor={card.glowColor || '#FC0021'}
                      width="367"
                      height="216"
                      iconBgColor="#11112E"
                      origin="finops"
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselButtonsMobile />
          </Carousel>
        </div>
      </Container>
    </div>
  )
}
